import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import {
  adminColumns,
  mapAdminListFromApi,
} from "./adminUtils";
import CommonTable from "../../common/CommonTable";
import { CommanSearchBox } from "../../common/commanSearchBox";
import AdminPermissionsModal from "./AdminPermissionsModal";
import { getAdminListHandler } from "../../redux/action/getAdminListSlice";
import Loader from "../Loder/loader";
import "./AdminManagement.css";

const AdminListing = () => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const getAdminListSelector = useSelector((state) => state?.getAdminList);
  const [adminList, setAdminList] = useState([]);
  const [searchValue, setSearchValue] = useState("");
  const [selectedAdmin, setSelectedAdmin] = useState(null);
  const [showPermissionsModal, setShowPermissionsModal] = useState(false);
  const [pagination, setPagination] = useState({
    current: 1,
    pageSize: 10,
    total: 0,
    showSizeChanger: true,
    pageSizeOptions: [5, 10, 15, 20],
    className: "order-pagination",
    locale: { items_per_page: "" },
    showTotal: (total, range) => `${range[0]}-${range[1]} of ${total}`,
  });

  const handleAdminListData = (
    offSet = 1,
    limit = 10,
    searchString = searchValue,
  ) => {
    window.scrollTo(0, 0);

    const payload = { offSet, limit };
    if (searchString?.trim()) {
      payload.searchString = searchString.trim();
    }

    dispatch(getAdminListHandler(payload));
  };

  useEffect(() => {
    handleAdminListData();
  }, []);

  useEffect(() => {
    const adminRecords = getAdminListSelector?.data?.data;
    if (adminRecords) {
      setAdminList(mapAdminListFromApi(adminRecords));
      const { totalElements, pageNumber, pageSize } =
        getAdminListSelector?.data || {};

      setPagination((prev) => ({
        ...prev,
        total: totalElements ?? adminRecords.length,
        current: pageNumber ?? prev.current,
        pageSize: pageSize ?? prev.pageSize,
      }));
    }
  }, [getAdminListSelector]);

  const handlePermissionClick = (admin) => {
    setSelectedAdmin(admin);
    setShowPermissionsModal(true);
  };

  const handleManageClick = (admin) => {
    navigate("/manage-admin", { state: { adminData: admin } });
  };

  const handleClosePermissionsModal = () => {
    setShowPermissionsModal(false);
    setSelectedAdmin(null);
  };

  const columns = adminColumns({
    onPermissionClick: handlePermissionClick,
    onManageClick: handleManageClick,
  });
  return (
    <>
      {getAdminListSelector?.isLoading && (
        <Loader loaderTransform="loaderTransform" />
      )}
      <div className="rightside">
        <div className="rightcontent">
          <p>
            <strong>Admin Management</strong>
          </p>

          <div className="table-padding">
            <div className="headtitle admin-list-header">
              <p className="mb-0 heedprodct">Permission List</p>
              <div className="admin-list-toolbar">
                <CommanSearchBox
                  value={searchValue}
                  setValue={setSearchValue}
                  getSearchValue={handleAdminListData}
                  placeholder=""
                />
                <button
                  className="primarybtn"
                  type="button"
                  onClick={() => navigate("/add-admin")}
                >
                  <div className="plus"></div>
                  Add Admin
                </button>
              </div>
            </div>
            <hr className="m-0" />
            <div className="table-responsive overfloauto">
              <CommonTable
                handlePageChange={handleAdminListData}
                pagination={pagination}
                body={adminList}
                columns={columns}
              />
            </div>
          </div>
        </div>

        <AdminPermissionsModal
          open={showPermissionsModal}
          onClose={handleClosePermissionsModal}
          permissionGroups={selectedAdmin?.permissionGroups || []}
        />
      </div>
    </>
  );
};

export default AdminListing;
